<template>
  <div>
    <Form ref="formInline" inline class="padding-blank no-margin-item" :label-width="40">
      <Form-item label="名称">
        <Input type="text" placeholder="Username" class="normal-form-item"></Input>
      </Form-item>

      <Form-item label="来源">
        <Select v-model="model1" class="normal-form-item">
          <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </Form-item>

      <Form-item label="状态">
        <Select v-model="model1" class="normal-form-item">
          <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </Form-item>

      <Form-item>
        <Button type="primary" icon="ios-search">搜索</Button>
      </Form-item>

    </Form>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        cityList: [
          {
            value: 'beijing',
            label: '北京市'
          },
          {
            value: 'shanghai',
            label: '上海市'
          },
          {
            value: 'shenzhen',
            label: '深圳市'
          },
          {
            value: 'hangzhou',
            label: '杭州市'
          },
          {
            value: 'nanjing',
            label: '南京市'
          },
          {
            value: 'chongqing',
            label: '重庆市'
          }
        ],
        model1: ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Query.vue?6c23f48a